module.exports = __webpack_public_path__ + "static/media/food-min.0f40c2ec.jpg";